import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { gutil } from '../gutil';
import { ActivatedRoute } from '@angular/router';
import { SafeHtml } from '@angular/platform-browser';
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleRight, faCalendar } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-static-page',
  templateUrl: './static-page.component.html',
  styleUrls: ['./static-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class StaticPageComponent implements OnInit {

  public id: number;
  public title:any;
  public content: SafeHtml;
  public checkpolicy:boolean;
  public checkleadership:boolean;
  public checkownerpolicy:boolean;
  public checkVideos:boolean;
  public checkPress:boolean;
  public checkAwards:boolean;
  public faAngleDoubleLeft = faAngleDoubleLeft;
  public faAngleDoubleRight = faAngleDoubleRight;
  public faAngleRight = faAngleRight;
  public checkAboutus:boolean;
  public aboutTitle:any;
  public aboutContent:SafeHtml;
  public checkPrivacyPolicy:boolean;
  public checkTermsOfUse:boolean;
  public mediaList : any;
  public fyYear : any;
  public faCalendar = faCalendar;
  public selectedYear : any;
  public selectedIndex : any = 0;

  constructor(private http: HttpClient, private routeact: ActivatedRoute, private router : Router) {

      this.id = routeact.snapshot.params['id']; 
      this.content = "";
      this.title = "";
   }

  ngOnInit(): void {    
    this.routeact.params.subscribe(params => {
      this.id = params['id']
      this.getPageData();
      this.fetchMediaList();
      this.changeFyYear('2022-23', 0);
  });  
  }

  

  public getPageData(){
    window.scrollTo(0,0);
    if(this.id == 23 || this.id == 22 || this.id == 24 || this.id == 42 || this.id == 41 || this.id == 26 || this.id == 40 || this.id == 39 || this.id == 30 || this.id == 29 || this.id == 32 || this.id == 31 || this.id == 38 || this.id == 15 || this.id == 28 || this.id == 27 || this.id == 21 || this.id == 20 || this.id == 12 || this.id == 55 || this.id == 58 || this.id == 59 || this.id == 60 || this.id == 61 || this.id == 62 || this.id == 63 || this.id == 64 ||this.id == 65 || this.id == 66){
        this.checkpolicy=true;
        this.checkleadership=undefined;
        this.checkownerpolicy=undefined;
        this.checkVideos = undefined;
        this.checkAwards = undefined;
        this.checkPress = undefined;
        this.checkAboutus = undefined;
        this.checkPrivacyPolicy = undefined;
        this.checkTermsOfUse = undefined;
        
    } else if(this.id == 25 || this.id == 13 || this.id == 7) {
        
        this.checkleadership=true;
        this.checkpolicy=undefined;
        this.checkownerpolicy=undefined;
        this.checkVideos = undefined;
        this.checkAwards = undefined;
        this.checkPress = undefined;
        this.checkAboutus = undefined;
        this.checkPrivacyPolicy = undefined;
        this.checkTermsOfUse = undefined;
        
    } else if(this.id == 34 || this.id == 43 || this.id == 44 || this.id == 45 || this.id == 46 || this.id == 47 || this.id == 49 || this.id == 50 || this.id == 51 || this.id == 52 || this.id == 53 || this.id == 54 || this.id == 56 || this.id == 72 || this.id == 73) {
        this.checkownerpolicy=true;
        this.checkpolicy=undefined;
        this.checkleadership=undefined; 
        this.checkVideos = undefined;
        this.checkAwards = undefined;
        this.checkPress = undefined;
        this.checkAboutus = undefined;
        this.checkPrivacyPolicy = undefined;
        this.checkTermsOfUse = undefined;
    }
    else if(this.id == 74) {
        this.checkownerpolicy=undefined;
        this.checkpolicy=undefined;
        this.checkleadership=undefined; 
        this.checkVideos = true;
        this.checkAwards = undefined;
        this.checkPress = undefined;
        this.checkAboutus = undefined;
        this.checkPrivacyPolicy = undefined;
        this.checkTermsOfUse = undefined;
    }
    else if(this.id == 14) {
        this.checkownerpolicy=undefined;
        this.checkpolicy=undefined;
        this.checkleadership=undefined; 
        this.checkVideos = undefined;
        this.checkAwards = undefined;
        this.checkPress = true;
        this.checkAboutus = undefined;
        this.checkPrivacyPolicy = undefined;
        this.checkTermsOfUse = undefined;
    }
    else if(this.id == 76) {
        this.checkownerpolicy=undefined;
        this.checkpolicy=undefined;
        this.checkleadership=undefined; 
        this.checkVideos = undefined;
        this.checkAwards = true;
        this.checkPress = undefined;
        this.checkAboutus = undefined;
        this.checkPrivacyPolicy = undefined;
        this.checkTermsOfUse = undefined;
    }
    else if(this.id == 3) {
        this.checkownerpolicy=undefined;
        this.checkpolicy=undefined;
        this.checkleadership=undefined; 
        this.checkVideos = undefined;
        this.checkAwards = undefined;
        this.checkPress = undefined;
        this.checkAboutus = true;
        this.checkPrivacyPolicy = undefined;
        this.checkTermsOfUse = undefined;
    }
    else if(this.id == 5 || this.id == 79  || this.id == 80 || this.id == 82 || this.id == 83 || this.id == 84 || this.id == 85 || this.id == 86 || this.id == 87 || this.id == 88 || this.id == 89 || this.id == 90 || this.id == 91 || this.id == 92 || this.id == 93 ) {
        this.checkPrivacyPolicy = true;
        this.checkownerpolicy=undefined;
        this.checkpolicy=undefined;
        this.checkleadership=undefined; 
        this.checkVideos = undefined;
        this.checkAwards = undefined;
        this.checkPress = undefined;
        this.checkAboutus = undefined;
        this.checkTermsOfUse = undefined;
    }
    else if(this.id == 9 || this.id == 94 || this.id == 95 || this.id == 96 || this.id == 97 || this.id == 98 || this.id == 99 || this.id == 100 || this.id == 101 || this.id == 102 || this.id == 103 || this.id == 105 || this.id == 106 || this.id == 107 || this.id == 108 || this.id == 109 || this.id == 110 || this.id == 111 || this.id == 112 || this.id == 113 || this.id == 114 || this.id == 115 || this.id == 116 ) {
        this.checkTermsOfUse = true;
        this.checkownerpolicy=undefined;
        this.checkpolicy=undefined;
        this.checkleadership=undefined; 
        this.checkVideos = undefined;
        this.checkAwards = undefined;
        this.checkPress = undefined;
        this.checkAboutus = undefined;
        this.checkPrivacyPolicy = undefined;
    }
    else {
      this.checkleadership=undefined;
      this.checkpolicy=undefined;
      this.checkownerpolicy=undefined;
      this.checkVideos = undefined;
      this.checkAwards = undefined;
      this.checkPress = undefined;
      this.checkAboutus = undefined;
      this.checkTermsOfUse = undefined;
      this.checkPrivacyPolicy = undefined;
    }
    this.http.get(gutil.apiUrl + '/api/w/v1/content/show/' + this.id)
      .subscribe((data:any) => {
        this.title = data.obj[0].name;
        this.content  = data.obj[0].value;
        
        if(this.id == 3) {
          this.dispAboutUs();
          
        }
      })
  }
  public dispAboutUs() {
    // var aboutUs = 78;
    this.http.get(gutil.apiUrl + '/api/w/v1/content/show/78')
        .subscribe((data:any) => {  
          this.aboutTitle = data.obj[0].name;
          this.aboutContent = data.obj[0].value;
        })
  }
  public dispIntoView() {
    let el = document.getElementById('disp_policies');
    el.scrollIntoView({behavior: 'smooth'});
    
  }

  media = {
    "2022-23" : [
      {
        "title" : "T1",
        "url" : 'http://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/',
        "image" : "I1"
      },
      {
        "title" : "T2",
        "url" :  'http://bwdisrupt.businessworld.in/article/YourOwnROOM-has-Raised-1-3-Million-in-Seed-Funding-from-US-Based-Investment-Firm-Lotus-Capital/06-11-2019-178581/',
        "image" : "I2"
      }
    ],
    "2021-22" : [
      {
        "title" : "T22",        
      },
      {
        "title" : "T22-1"
      }
    ]
  }
  
  public fetchMediaList() {

    this.getFinancialYears();

    //MEDIA DUMMY LIST
    this.mediaList = {
      "Startup Story" : {
        "image": "assets/images/news/startup-story.png",
        "data" : [
          {
            'url' : 'https://startupstorymedia.com/startuptv/prop-tech-is-the-new-growth-catalyst-in-residential-real-estate-prabhat-kumar-tiwary-yourownroom/',
            'title': 'YourOwnROOM, a Proptech Residential real estate asset management company with...',
            'date' : '23-04-2022'
          }
        ]
      },
      "Your Story" : {
        "image" : "assets/images/news/news_yourstory.png",
        "data" : [
          {
            'url': 'https://yourstory.com/2019/11/funding-startup-proptech-yourownroom-coliving-seed/amp',
            'title': 'Proptech startup YourOwnRoom raises $1.3M to scale...',
            'date' : '06-11-2019'
          },
          {
            'url' : 'https://www.facebook.com/yourstorycom/videos/2356093704666969/',
            'title' : 'Cut your traffic time by 15mins, stay close to your workplace...',
            'date' : '22-04-2019'
          }
        ]
      },
      "Times Of India" : {
        "image" : "assets/images/news/TOI.png",
        "data" : [
          {
            'url' : 'https://timesofindia.indiatimes.com/india/co-living-is-booming-and-millennials-are-to-be-thanked/articleshow/73792002.cms',
            'title' : 'Co-Living is booming and millennials are to be thanked...',
            'date' : '31-01-2020'
          }
        ]
      },
      "BW Disrupt" : {
        "image" : "assets/images/news/news_full-Disrupt-logo.png",
        "data" : [
          {
            'url': 'http://bwdisrupt.businessworld.in/article/YourOwnROOM-has-Raised-1-3-Million-in-Seed-Funding-from-US-Based-Investment-Firm-Lotus-Capital/06-11-2019-178581/',
            'title': 'YourOwnROOM has Raised $1.3 Million in Seed Funding...',
            'date' : '06-11-2019'
          },
          {
            'url' : 'http://bwdisrupt.businessworld.in/article/YourOwnRoom-a-750K-Seed-Funded-Co-living-Home-Rental-Company-Expands-Footprint-in-Bangalore-Pune/08-10-2018-161713/',
            'title' : 'YourOwnRoom, a $750K Seed Funded Co-living Home...',
            'date' : '08-10-2018'
          }
        ]
      }
    }
    this.mediaList = Object.entries(this.mediaList);    

  }

  public changeFyYear(fyYear: any, index: any) {    
    this.selectedIndex = index;    
    this.selectedYear = fyYear;

    // console.log(this.selectedIndex);
    console.log("The Selected Financial Year is :", this.selectedYear);

    console.log("The media is:", this.media);    
    for(let i in this.media) {
      console.log(this.media[i]);      
    }

    this.getFYMediaList(this.selectedYear)

  }

  public getFYMediaList(fyYear: any) {
    
    fyYear =  fyYear.split("-");
    let minFyYear = fyYear[0];
    let maxFyYear = "20" + fyYear[1];    

    // console.log(typeof(this.mediaList))
    // for(let i in this.mediaList) {
    //   console.log(this.mediaList[i]);
    // }
    
  }

  // Array to get all the Financial Years till date
  public getFinancialYears() {
    
    let currentYear = new Date().getFullYear()    
    let startYear = 2016;
    let years = []
    let nextYears = currentYear - 1;
    for (let i = startYear; i <= currentYear; i++) {      
      nextYears = i + 1;
      years.push(i + '-' + nextYears);

    }        
    this.fyYear = Object.entries(years).reverse();    
    return years
  }

  public mediaFyYears() {

  
  }
  
}